import { render, staticRenderFns } from "./appleSpotifyRelase.vue?vue&type=template&id=228d94f0&scoped=true"
import script from "./appleSpotifyRelase.vue?vue&type=script&lang=js"
export * from "./appleSpotifyRelase.vue?vue&type=script&lang=js"
import style0 from "./appleSpotifyRelase.vue?vue&type=style&index=0&id=228d94f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228d94f0",
  null
  
)

export default component.exports